import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39a78b08"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Add Services", -1))
const _hoisted_3 = { class: "specialisms_multiselect_modal_body" }
const _hoisted_4 = { class: "specialisms_multiselect_modal_search" }
const _hoisted_5 = {
  key: 0,
  class: "specialisms_multiselect_modal_inner no-scrollbar"
}
const _hoisted_6 = { class: "specialisms_multiselect_modal_item_heading" }
const _hoisted_7 = ["value", "checked", "onClick"]
const _hoisted_8 = { class: "specialisms_multiselect_modal_item_title" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "specialisms_multiselect_modal_item_title_text" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "specialisms_multiselect_modal_item_content" }
const _hoisted_13 = { class: "specialisms_multiselect_modal_item_input_wrapper" }
const _hoisted_14 = {
  key: 0,
  class: "tw-text-red-600"
}
const _hoisted_15 = {
  key: 1,
  class: "tw-mx-auto tw-flex tw-justify-center"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Not any Services Found", -1))
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 2,
  class: "tw-mx-auto tw-flex tw-justify-center"
}
const _hoisted_19 = { class: "tw-w-full tw-flex tw-gap-3 tw-items-center tw-justify-end tw-pt-4 tw-border-t-dashed-custom" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Text = _resolveComponent("Text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_CommonLoader = _resolveComponent("CommonLoader")!
  const _component_Button = _resolveComponent("Button")!
  const _component_CommonDialog = _resolveComponent("CommonDialog")!

  return (_openBlock(), _createBlock(_component_CommonDialog, {
    isShowHeader: false,
    isShowBackButton: false,
    width: "570px",
    "max-width": "100%",
    persistent: "",
    className: ['specialisms_multiselect_modal ']
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_v_icon, {
          icon: "mdi-close",
          class: "close__icon",
          onClick: $setup.onClickCancel
        }, null, 8, ["onClick"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_btn, {
          class: "button button-purple-border",
          block: "",
          onClick: $setup.onClickAddNewTradeSpecialism
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Text, { variant: "span" }, {
              default: _withCtx(() => [
                _createTextVNode(" add new trade Services ")
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_text_field, {
            variant: "outlined",
            placeholder: "Search Services",
            "prepend-inner-icon": "mdi-magnify",
            onInput: $setup.debouncedCategoryFilter
          }, null, 8, ["onInput"])
        ]),
        ($setup.filterCategory.length && !$setup.servicesLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_v_expansion_panels, {
                modelValue: $setup.panel,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.panel) = $event)),
                multiple: ""
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filterCategory, (specialism, index) => {
                    return (_openBlock(), _createBlock(_component_v_expansion_panel, { key: index }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel_title, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("input", {
                                type: "checkbox",
                                class: "custom-chekbox",
                                id: "checkbox-{{ specialism.id }}",
                                value: specialism.id,
                                checked: $setup.isMainCategorySelected(specialism),
                                onClick: ($event: any) => ($setup.onClickMainCategory(specialism)),
                                style: {"accent-color":"#4b4bff","transform":"scale(1.3)"}
                              }, null, 8, _hoisted_7),
                              _createElementVNode("div", _hoisted_8, [
                                (specialism.iconName)
                                  ? (_openBlock(), _createBlock(_component_v_icon, {
                                      key: 0,
                                      class: "specialisms_multiselect_modal_item_title_icon"
                                    }, {
                                      default: _withCtx(() => [
                                        (specialism.iconName)
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              style: {"width":"14px"},
                                              src: 
                          require('@/assets/category-icons/' +
                            specialism.iconName +
                            '.svg')
                        ,
                                              alt: "icon"
                                            }, null, 8, _hoisted_9))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_10, [
                                  _createElementVNode("h2", null, _toDisplayString(specialism?.poLabel), 1),
                                  _createElementVNode("p", null, [
                                    _createTextVNode(_toDisplayString(specialism.subCategories
                            .slice(0, 2)
                            .map((sub) => sub.label)
                            .join(", ")) + " ", 1),
                                    (specialism.subCategories?.length > 2)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, " etc.."))
                                      : _createCommentVNode("", true)
                                  ])
                                ])
                              ])
                            ])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_expansion_panel_text, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, [
                                _createVNode(_component_v_text_field, {
                                  class: "specialisms_multiselect_modal_item_input",
                                  variant: "outlined",
                                  placeholder: "Enter sub-category",
                                  id: specialism.id,
                                  modelValue: $setup.newSubCategory[specialism.id],
                                  "onUpdate:modelValue": ($event: any) => (($setup.newSubCategory[specialism.id]) = $event),
                                  onInput: _cache[0] || (_cache[0] = ($event: any) => ($setup.subCategoryValidationError = ''))
                                }, null, 8, ["id", "modelValue", "onUpdate:modelValue"]),
                                ($setup.subCategoryValidationErrorId === specialism.id)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString($setup.subCategoryValidationError), 1))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_btn, {
                                  class: "button button-purple-border",
                                  density: "compact",
                                  onClick: ($event: any) => ($setup.onClickAddSubCategory(specialism.id)),
                                  disabled: 
                        !$setup.newSubCategory[specialism.id] ||
                        $setup.newSubCategory[specialism.id].length > 25
                      ,
                                  icon: "mdi-plus"
                                }, null, 8, ["onClick", "disabled"])
                              ]),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(specialism.subCategories, (subCategory) => {
                                return (_openBlock(), _createBlock(_component_v_checkbox, {
                                  color: "#4B4BFF",
                                  modelValue: $setup.selectedSubCategory,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.selectedSubCategory) = $event)),
                                  label: subCategory.label,
                                  key: subCategory.id,
                                  value: subCategory.id
                                }, null, 8, ["modelValue", "label", "value"]))
                              }), 128))
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true),
        (!$setup.filterCategory.length && !$setup.servicesLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
          : _createCommentVNode("", true),
        ($setup.servicesLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createVNode(_component_CommonLoader, { loading: true })
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_Button, {
            variant: "secondary",
            label: "Cancel",
            isCapitalize: true,
            onClick: $setup.onClickCancel,
            class: "!tw-w-auto"
          }, null, 8, ["onClick"]),
          _createVNode(_component_Button, {
            variant: "accent",
            label: "CONTINUE",
            isCapitalize: true,
            onClick: $setup.onClickContinue,
            class: "!tw-w-auto"
          }, null, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }))
}